import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EmptyTimesheets as EmptyTimesheetsIllustration } from 'WeployDesignLanguage/illustrations';

const EmptyTimesheetsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledIllustrationContainer = styled.div`
  margin: ${props => props.theme.spacing[3]} 0;
`;

const StyledHeading = styled.h5`
  margin-bottom: ${props => props.theme.spacing[1]};
`;

const StyledSubtitle = styled.p`
  ${props => props.theme.typography.body2}
  color: ${props => props.theme.colors.text.primary};
  margin-top: ${props => props.theme.spacing[0]};
`;

const EmptyTimesheets = ({ title, description }) => (
  <EmptyTimesheetsWrapper>
    <StyledIllustrationContainer>
      <EmptyTimesheetsIllustration />
    </StyledIllustrationContainer>
    <StyledHeading>{title}</StyledHeading>
    <StyledSubtitle>{description}</StyledSubtitle>
  </EmptyTimesheetsWrapper>
);

EmptyTimesheets.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default EmptyTimesheets;
